import { render } from "./create-booking-client.vue?vue&type=template&id=d4a7d9ae&ts=true"
import script from "./create-booking-client.vue?vue&type=script&lang=ts"
export * from "./create-booking-client.vue?vue&type=script&lang=ts"

import "./create-booking-client.vue?vue&type=style&index=0&id=d4a7d9ae&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__